/**
 * Landing Declaration Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: support@indigo.si
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EPrinterPresenterPaperStatus = 'Ok' | 'Empty' | 'NearEnd' | 'Detected' | 'PaperJam';

export const EPrinterPresenterPaperStatus = {
    Ok: 'Ok' as EPrinterPresenterPaperStatus,
    Empty: 'Empty' as EPrinterPresenterPaperStatus,
    NearEnd: 'NearEnd' as EPrinterPresenterPaperStatus,
    Detected: 'Detected' as EPrinterPresenterPaperStatus,
    PaperJam: 'PaperJam' as EPrinterPresenterPaperStatus
};

